<div class="dx-card wide-card">
    <h4 class="content-block ap-green">Site Refinery Balance</h4>
    <div class="content-block"><b class="content-block">{{siteName}} ({{siteId}})</b></div>
    <div class="content-block"><b class="content-block">{{city}}</b></div>
    <div class="content-block"><b class="content-block">{{province}}</b></div>
    <div class="content-block"><b class="content-block">{{countryName}} ({{latitude}}, {{longitude}})</b></div>
    <div class="content-block"><b class="content-block">Supply = +ve Demand = -ve</b>
        <b class="content-block" class="floatRight">{{currentDate| date: 'dd MMM yyyy'}}</b>
    </div>
    <div class="content-block"></div>
    <div class="btndiv">
        <dx-button icon="back" text="Back" type="default" class="backbtn" (onClick)="onBackbtnClicked($event)">
        </dx-button>
    </div>
    <dx-data-grid #RefineryBalanceGrid class="gridmargin" id="RefineryBalanceGrid" [dataSource]="refineryBalancesBySite"
        [showRowLines]="true" [showColumnLines]="true" [showBorders]="true" [allowColumnResizing]="false"
        [rowAlternationEnabled]="true">
        <dxo-sorting mode="multiple"></dxo-sorting>
        <dxo-scrolling columnRenderingMode="virtual"></dxo-scrolling>
        <dxo-column-fixing [enabled]="true"></dxo-column-fixing>
        <dxi-column [width]="100" dataField="productionFacilityID" alignment="center">
        </dxi-column>
        <dxi-column [width]="300" dataField="specificProcessName" caption="Process" alignment="center">
        </dxi-column>
        <dxi-column dataField="status" [width]="100" ></dxi-column>
        <dxi-column dataField="onstreamYear" caption="Year" [width]="100"></dxi-column>
        <dxi-column dataField="capacitybbl_d" caption="Capacity bbl/dy" [width]="100">
            <dxo-format type="fixedPoint" [precision]="0"></dxo-format>
        </dxi-column>
        <dxi-column dataField="h2Existingmmscfd" caption="H2 Existing mmscfd" [width]="100">
            <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
        </dxi-column>
        <dxi-column dataField="h2Potentialmmscfd" caption="H2 Potential mmscfd" [width]="100">
            <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
        </dxi-column>
        <dxi-column dataField="oxygenExistingtpd" caption="Oxygen Existing tpd" [width]="100">
            <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
        </dxi-column>
        <dxi-column dataField="oxygenPotentialtpd" caption="Oxygen Potential tpd" [width]="100">
            <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
        </dxi-column>
        <dxi-column dataField="productionFacilityNotes" [width]="500" caption="Notes"></dxi-column>
        <dxo-summary>
            <dxi-total-item [customizeText]="getLabel" alignment="left" column="specificProcessName">
            </dxi-total-item>
            <dxi-total-item [customizeText]="getH2Total" alignment="right" column="h2Existingmmscfd" summaryType="sum">
            </dxi-total-item>
            <dxi-total-item [customizeText]="getSumValueOnly" column="h2Potentialmmscfd" alignment="right"
                summaryType="sum">
            </dxi-total-item>
            <dxi-total-item [customizeText]="getO2Total" column="oxygenExistingtpd" alignment="right" summaryType="sum">
            </dxi-total-item>
            <dxi-total-item [customizeText]="getSumValueOnly" column="oxygenPotentialtpd" alignment="right"
                summaryType="sum">
            </dxi-total-item>
        </dxo-summary>
    </dx-data-grid>
    <div class="content-block"></div>
    <dx-data-grid #RefiningSiteProductionFacilityPipelineSummaryGrid
        id="RefiningSiteProductionFacilityPipelineSummaryGrid"
        [dataSource]="refiningSiteProductionFacilityPipelineSummary" class="gridmargin" [showRowLines]="true" [showColumnLines]="true"
        [showBorders]="true" [allowColumnResizing]="false" [rowAlternationEnabled]="true">
        <dxo-sorting mode="multiple"></dxo-sorting>
        <dxo-scrolling columnRenderingMode="virtual"></dxo-scrolling>
        <dxo-column-fixing [enabled]="true"></dxo-column-fixing>
        <dxi-column [width]="400" dataField="pipelineCode" caption="Supplier" alignment="center">
        </dxi-column>
        <dxi-column dataField="mode" [width]="100"></dxi-column>
        <dxi-column [width]="100"></dxi-column>
        <dxi-column [width]="100"></dxi-column>
        <dxi-column dataField="pipelineQtymmscf_d" caption="H2 Volume mmscfd" [width]="100">
            <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
        </dxi-column>
        <dxi-column [width]="100"></dxi-column>
        <dxi-column dataField="pipelineQtytons_d" caption="O2 Volume tpd" [width]="100">
            <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
        </dxi-column>
        <dxi-column [width]="100"></dxi-column>
        <dxi-column dataField="pipelineNotes" [width]="500">
        </dxi-column>
        <dxo-summary>
            <dxi-total-item [customizeText]="getLabel" alignment="left" column="pipelineCode"></dxi-total-item>
            <dxi-total-item [customizeText]="getH2Total" alignment="right" column="pipelineQtymmscf_d" summaryType="sum">
            </dxi-total-item>
            <dxi-total-item [customizeText]="getO2Total" alignment="right" column="pipelineQtytons_d" summaryType="sum">
            </dxi-total-item>
        </dxo-summary>
    </dx-data-grid>
    <dx-data-grid #NetSurplus class="gridmargin" id="NetSurplus" [dataSource]="netSurplusData" [showRowLines]="true"
        [showColumnLines]="true" [showBorders]="true" [allowColumnResizing]="false" [rowAlternationEnabled]="true">
        <dxo-sorting mode="multiple"></dxo-sorting>
        <dxo-scrolling columnRenderingMode="virtual"></dxo-scrolling>
        <dxo-column-fixing [enabled]="true"></dxo-column-fixing>
        <dxi-column [width]="400" dataField="netSurplus" caption="" alignment="left" cellTemplate="cellTemplate">
        </dxi-column>
        <dxi-column [width]="100"></dxi-column>
        <dxi-column [width]="100"></dxi-column>
        <dxi-column [width]="100"></dxi-column>
        <dxi-column dataField="h2NetSurplus" caption="">
            <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
        </dxi-column>
        <dxi-column [width]="100"></dxi-column>
        <dxi-column>
            <dxi-column dataField="o2NetSurplus" caption="">
                <dxo-format type="fixedPoint" [precision]="1"></dxo-format>
            </dxi-column>
        </dxi-column>
        <dxi-column [width]="100"></dxi-column>
        <dxi-column [width]="100">
        </dxi-column>
        <div *dxTemplate="let data of 'cellTemplate'">
            <b>{{data.value}}</b>
        </div>
    </dx-data-grid>
    <div class="marginL10 dx-fieldset-header"><b>Questions/Notes section</b></div>
    <dx-text-area class="gridmargin" [height]="90" [readOnly]="true" [autoResizeEnabled]="true" [(value)]="siteComment">
    </dx-text-area>
</div>